import { render, staticRenderFns } from "./UltimaCapacitacion.vue?vue&type=template&id=d772af38&"
import script from "./UltimaCapacitacion.vue?vue&type=script&lang=js&"
export * from "./UltimaCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports